module.exports = __webpack_public_path__ + "img/DPC_ACADEMY_WHITE.22d0ce31.png";